.workForm {
  &__options {
    margin-top: 10px;
    width: 100%;
    justify-content: space-between;
  }

  &__input {
    width: 150px;
  }

  &__desiredPosition {
    margin-top: 10px;
  }

  &__dateSmall {
    width: 75px;
    @media (max-width: 441px) {
      width: 70px;
    }
  }

  &__dateBig {
    width: 125px;
    @media (max-width: 441px) {
      width: 100px;
    }
  }

  &__availability {
    width: 350px;
    margin-top: 10px;
  }
}
